<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiAlertCircleOutline } from "@mdi/js";
export default {
  name: "MdiCrosshairsGps",
  data() {
    return {
      svgPath: mdiAlertCircleOutline,
    };
  },
};
</script>
